"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("../config");
const vector_1 = require("../core/vector");
const errors_1 = require("../pathfinding/errors");
const utils_1 = require("../utils");
class Tile {
    constructor(location, size, _travelCost, diagonalMovementCost) {
        this.location = location;
        this.size = size;
        this._travelCost = _travelCost;
        this.diagonalMovementCost = diagonalMovementCost;
    }
    get isObstacle() {
        return this.travelCost === 1;
    }
    get travelCost() {
        return this._travelCost;
    }
    setWorld(world) {
        this.world = world;
    }
    getNeighbors(area = this.world) {
        const neighbors = area.getNeighbors(this);
        const result = new Map();
        for (const neighbor of neighbors)
            if (!neighbor.isObstacle || neighbor === this)
                result.set(neighbor, {
                    cost: this.isAdjacent(neighbor) ? 1 : this.diagonalMovementCost,
                });
        return result;
    }
    getCostTo(neighbor) {
        const tile = neighbor;
        if (this === neighbor)
            return 0;
        if (this.isAdjacent(tile))
            return 1;
        if (this.isDiagonal(tile))
            return this.diagonalMovementCost;
        debugger;
        throw new Error('Argument should be a neighbor');
    }
    estimateDistanceTo(tile) {
        const diff = vector_1.default.diff(this.location, tile.location).abs();
        const layerMovement = diff.x > diff.y
            ? this.diagonalMovementCost * 10 * diff.y + 10 * (diff.x - diff.y)
            : this.diagonalMovementCost * 10 * diff.x + 10 * (diff.y - diff.x);
        return utils_1.round(layerMovement); // + z * LAYER_CHANGE_COST;
    }
    isNeighbor(other) {
        if (!(other instanceof Tile))
            throw new errors_1.SubclassExpectedError(`Expected Tile but ${other.constructor.name} found`);
        return this.isAdjacent(other) || this.isDiagonal(other);
    }
    isAdjacent(other) {
        return vector_1.default.diff(this.location, other.location).magnitude === 1;
    }
    isDiagonal(other) {
        return (vector_1.default.diff(this.location, other.location).magnitude ===
            vector_1.default.round(Math.SQRT2));
    }
    print(ctx, drawGrid) {
        const x = this.location.x * this.size;
        const y = this.location.y * this.size;
        const obstacleColor = 'purple';
        if (drawGrid) {
            utils_1.drawSquare(ctx, x, y, this.size, {
                color: this.isObstacle ? obstacleColor : config_1.Color.TILE.toString(),
            });
        }
        if (this.isObstacle) {
            ctx.fillStyle = obstacleColor;
            ctx.fillRect(x, y, this.size, this.size);
        }
        if (this.color) {
            ctx.fillStyle = this.color;
            ctx.fillRect(x, y, this.size, this.size);
        }
        if (this.content) {
            ctx.font = '14px Arial';
            ctx.textAlign = 'center';
            ctx.fillStyle = 'black';
            ctx.fillText(this.content, x + this.size / 2, y + this.size - 2);
        }
    }
    toString() {
        return `[Tile(${this.location.toJSON()})]`;
    }
}
exports.default = Tile;



//////////////////
// WEBPACK FOOTER
// ./src/world/tile.ts
// module id = 13
// module chunks = 0